import React from 'react';

const CelebratoryAnniversaryBlock = ({ data }) => {
  return (<>
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch">
        {/* Image Section */}
        <div className="order-1 lg:order-1 my-auto py-8">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-yellow-400 rounded-3xl transform rotate-3 opacity-20"></div>
            <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden">
              <img
                src="/main-photo-2.jpg"
                alt="5 años celebrando juntos"
                className="w-full h-[400px] sm:h-[600px] lg:h-[650px] xl:h-[800px] object-cover"
              />
              <div className="absolute top-4 left-4 bg-brand-red text-white px-4 py-2 rounded-full text-sm font-bold">
                🎉 5 AÑOS
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="order-2 lg:order-2 bg-white text-start content-center py-12 px-6 sm:px-8 md:py-16 lg:py-20 lg:pl-12 lg:pr-16">
          <div className="max-w-2xl">
            <div className="mb-6">
              <h2 className="text-4xl lg:text-5xl font-brand-mulish text-brand-red font-bold mb-2">
                ¡Celebramos <br className="hidden lg:block" /> 5 años!
              </h2>
              <h3 className="text-2xl lg:text-3xl font-brand-mulish text-gray-800">
                ¡Y vos podés ganarte un terreno! 🏡
              </h3>
            </div>

            <p className="text-lg md:text-xl font-brand-mulish text-gray-600 mb-8 leading-relaxed">
              Porque creemos en regalar futuro, queremos premiar tu confianza con la oportunidad de tener tu propio espacio en la naturaleza. 🌿
            </p>

            <div className="bg-gray-50 p-6 mb-6">
              <h4 className="text-xl font-bold text-gray-800 mb-4">
                ¿Querés participar? ¡Es muy fácil!
              </h4>
              <div className="space-y-3 text-left">
                <div className="flex items-start space-x-4">
                  <span className="flex-shrink-0 w-8 h-8 bg-brand-red text-white flex items-center justify-center font-bold text-sm">1</span>
                  <p className="text-gray-700 text-lg">
                    Seguí nuestra cuenta{' '}
                    <a
                      href="https://www.instagram.com/tginmobiliaria_"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-semibold text-brand-red hover:underline"
                    >
                      @tginmobiliaria_
                    </a>
                  </p>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="flex-shrink-0 w-8 h-8 bg-brand-red text-white flex items-center justify-center font-bold text-sm">2</span>
                  <p className="text-gray-700 text-lg">Dale like al post del sorteo</p>
                </div>
                <div className="flex items-start space-x-4">
                  <span className="flex-shrink-0 w-8 h-8 bg-brand-red text-white flex items-center justify-center font-bold text-sm">3</span>
                  <p className="text-gray-700 text-lg">Etiquetá a 2 personas (ambos deben seguir la página)</p>
                </div>
              </div>
            </div>

            <div className="text-center bg-brand-light text-white p-4 mb-6">
              <span className="text-lg font-bold text-brand-red inline-flex items-center">
                📅 ¡Tenés tiempo hasta el 31 de enero de 2026!
              </span>
            </div>

            <div className="mt-6 text-center">
              <a
                href="https://api.whatsapp.com/send?phone=595984577585&text=¡Hola!%20Quiero%20participar%20en%20el%20sorteo%20de%20los%205%20años%20de%20Tierra%20Guaraní.%20¿Cómo%20puedo%20hacerlo?"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-white bg-brand-yellow hover:bg-brand-red border-2 border-brand-yellow px-6 py-3 shadow-sm cursor-pointer hover:shadow-md transition-colors"
              >
                <span className="text-2xl mr-3">🎁</span>
                <span className="text-lg font-semibold">
                  ¡Quiero participar!
                </span>
              </a>
            </div>

            <p className="text-center text-sm text-gray-500 mt-6">
              📌 <a
                href="/bases-y-condiciones"
                className="text-brand-red hover:underline font-medium"
              >
                Ver términos y condiciones del sorteo
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </>);
};

export default CelebratoryAnniversaryBlock;